import { css } from "lit";

export const packageButtonStyles = css`
  umb-market-button {
    --button-color: white;
    --button-hover-color: white;
    --button-padding: var(--uui-size-4) var(--uui-size-5);
    --button-background: var(--uui-color-current-contrast);
    margin-bottom: 10px;
    align-items: center;
  }

  umb-market-button:hover {
    --button-background: var(--uui-color-default);
  }

  umb-market-button:hover .btn-icon {
    --fill: var(--uui-color-surface);
  }

  .btn-text {
    max-width: calc(100% - var(--xl-spacer));
    overflow: hidden;
    text-overflow: ellipsis;
  }

  umb-market-button + umb-market-button {
    margin-top: var(--s-spacer);
  }

  .btn-subtitle {
    opacity: 0.7;
    font-size: 12px;
    line-height: var(--s-spacer);
    display: block;
    text-align: left;
  }

  .btn-icon {
    width: 36px;
    height: 36px;
    margin-left: auto;
    box-sizing: border-box;
    padding-left: 3px; /** visual adjustment for center alignment */
    display: flex;
    align-items: center;
    justify-content: center;
    --fill: var(--uui-color-surface);
  }

  .btn-icon span:last-of-type {
    display: none;
    white-space: nowrap;
    margin-right: 6px;
  }

  .btn-icon.copied {
    width: auto;
    border-radius: 18px;
    font-size: 14px;
    padding: 0 4px 0 0;
    color: var(--uui-color-surface);
  }

  .btn-icon.copied span:last-of-type {
    display: inline;
  }

  .btn-title {
    white-space: nowrap;
  }
`;
